import injectSheet from 'react-jss'
import CustomTourOperator from './CustomTourOperator'
import styles from './CustomTourOperator.styles'

export default injectSheet(styles)(CustomTourOperator)
